/*
 * Gift cart. Own gbc-* drawer (not the BYOB cart / #bmb-drawer).
 * Same skeleton: review drawer, one-time only, Checkout, pan pre-added.
 */
(function () {
  if (window.__atomeGiftBoxCartInstalled) return;
  window.__atomeGiftBoxCartInstalled = true;

  var DATA = window.GBC_DATA || {};
  var PAN = DATA.pan || null;
  var CAST_IRON = DATA.castIron || null;
  var BOX = DATA.box || null;
  var GIFT_NOTE_HANDLE = 'gift-note';
  var SHIP = DATA.ship || {};

  var S = {
    yourSelections: 'Your selections',
    yourBakingPan: 'Your baking pan',
    panNeededForBreads: 'Needed to bake the breads in your box',
    whyNeedPan: 'Why do you need a pan?',
    whyNeedPanTitle: 'Why you need a pan',
    panSteamTrap: 'The Steam Trap',
    panSteamTrapDesc: 'Trapped moisture lets dough develop slowly, creating a perfectly crispy crust',
    panMadeForAtome: 'Made for Atome',
    panMadeForAtomeDesc: 'All our products are designed to fit our pan perfectly',
    panWithout: 'Without a pan',
    panWithoutDesc: 'The crust dries first, preventing the dough from developing properly',
    panLightOrPremium: 'Light or Premium',
    panLightOrPremiumDesc: 'Choose the Atome Pan ($10) or upgrade to the Cast-Iron Pan ($120)',
    panDisclaimer: 'Changed your mind? Add the Atome Pan anytime.',
    panPromptHeadline: 'Your loaf needs the pan to bake right',
    panPromptSupport: 'Shape and crust done right, a $40 pan for $10.',
    panPromptYes: 'Yes, add the pan',
    panPromptNo: 'I have one',
    panPromptAdded: "Pan added. Your loaf's covered.",
    panGateHint: 'Quick question: choose a pan option above',
    choosePanOption: 'Choose pan option',
    addTheAtomePan: 'Add The Atome Pan',
    upgradeToCastIron: 'Upgrade to Cast Iron',
    switchToAluminium: 'Switch to Aluminium Pan',
    remove: 'Remove',
    save: 'SAVE',
    subtotal: 'Subtotal',
    checkout: 'Checkout',
    shipNode: SHIP.reached || 'Free shipping',
    shippingFeeApplies: 'Shipping fee applies',
    oneTime: 'One-time purchase',
    included: 'Included',
    alertCartError: 'Could not add items to cart.',
    alertCartFail: 'Could not prepare your cart. Please try again.',
    checkoutNetworkError: 'We could not reach checkout. Check your connection and try again.'
  };

  var CHECKOUT_CART_TIMEOUT_MS = 12000; // /cart/clear.js and /cart/add.js, same as the builder

  var STATE = {
    open: false,
    qty: 1,
    properties: { _gift: 'true' },
    panVariantId: null,
    isPanCastIron: false,
    panUserIntent: null,
    panJustAdded: false,
    checkoutInProgress: false,
    checkoutError: ''
  };

  function $(id) { return document.getElementById(id); }
  function esc(str) {
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
  }
  // Theme setting cart_free_shipping_threshold (cents); 14900 only if the setting is unreadable.
  function shipThresholdCents() {
    return SHIP.thresholdCents > 0 ? SHIP.thresholdCents : 14900;
  }
  function fmt(cents) {
    var n = (cents || 0) / 100;
    return '$' + n.toFixed(2).replace(/\.00$/, '');
  }
  function panData() {
    return STATE.isPanCastIron ? CAST_IRON : PAN;
  }
  function panCents() {
    if (!STATE.panVariantId) return 0;
    var p = panData();
    return p ? p.price : 0;
  }
  function boxCents() {
    return (BOX && BOX.price ? BOX.price : 0) * STATE.qty;
  }
  function totalCents() {
    return boxCents() + panCents();
  }

  function isGiftForm(form) {
    if (!form) return false;
    if (form.getAttribute && form.getAttribute('data-gbc-form') === 'true') return true;
    try {
      var fd = new FormData(form);
      if (String(fd.get('properties[_gift]')) === 'true') return true;
    } catch (err) {}
    if (form.querySelector) {
      var nested = form.querySelector('[name="properties[_gift]"]');
      if (nested && String(nested.value) === 'true') return true;
    }
    if (form.id) {
      var associated = document.querySelector('[name="properties[_gift]"][form="' + form.id + '"]');
      if (associated && String(associated.value) === 'true') return true;
    }
    if (DATA.box && DATA.box.productId && form.id && form.id.indexOf('product-form-' + DATA.box.productId + '-') === 0) {
      return true;
    }
    return false;
  }

  function interceptGift(e, form) {
    if (!isGiftForm(form)) return false;
    e.preventDefault();
    e.stopImmediatePropagation();
    openCart(form);
    return true;
  }

  function readForm(form) {
    var props = { _gift: 'true' };
    if (!form) return { qty: 1, properties: props, variantId: BOX && BOX.variantId };
    var fd = form instanceof FormData ? form : new FormData(form);
    var qty = parseInt(fd.get('quantity'), 10);
    if (!qty || qty < 1) qty = 1;
    fd.forEach(function (value, key) {
      var m = key.match(/^properties\[(.+)\]$/);
      if (!m) return;
      var name = m[1];
      if (name.charAt(0) === '_' && name !== '_gift' && name !== '_delivery_week') return;
      if (value == null || String(value).trim() === '') return;
      props[name] = String(value);
    });
    props._gift = 'true';
    var vid = parseInt(fd.get('id'), 10);
    return {
      qty: qty,
      properties: props,
      variantId: vid || (BOX && BOX.variantId)
    };
  }

  function applyFormState(form) {
    var read = readForm(form);
    STATE.qty = read.qty;
    STATE.properties = read.properties;
    if (read.variantId && BOX) BOX.variantId = read.variantId;
  }

  function openCart(form) {
    applyFormState(form);
    STATE.open = true;
    var drawer = $('gbc-drawer');
    var backdrop = $('gbc-backdrop');
    if (drawer) drawer.classList.add('gbc-drawer--open');
    if (backdrop) {
      backdrop.classList.add('gbc-backdrop--visible');
      backdrop.setAttribute('aria-hidden', 'false');
    }
    document.body.style.overflow = 'hidden';
    document.documentElement.classList.add('atome-gift-drawer-open');
    render();
  }

  function closeCart() {
    STATE.open = false;
    var drawer = $('gbc-drawer');
    var backdrop = $('gbc-backdrop');
    if (drawer) drawer.classList.remove('gbc-drawer--open');
    if (backdrop) {
      backdrop.classList.remove('gbc-backdrop--visible');
      backdrop.setAttribute('aria-hidden', 'true');
    }
    document.body.style.overflow = '';
    document.documentElement.classList.remove('atome-gift-drawer-open');
    closePanWarning();
  }

  function showPanWarning() {
    var el = $('gbc-pan-warning');
    if (el) el.classList.add('gbc-modal-overlay--open');
  }
  function closePanWarning() {
    var el = $('gbc-pan-warning');
    if (el) el.classList.remove('gbc-modal-overlay--open');
  }
  function removePan() {
    STATE.panVariantId = null;
    STATE.isPanCastIron = false;
    STATE.panUserIntent = 'removed';
    closePanWarning();
    render();
  }
  function addPan() {
    if (!PAN) return;
    STATE.panVariantId = PAN.variantId;
    STATE.isPanCastIron = false;
    STATE.panUserIntent = 'added';
    STATE.panJustAdded = true;
    render();
  }

  function declinePan() {
    STATE.panVariantId = null;
    STATE.isPanCastIron = false;
    STATE.panUserIntent = 'removed';
    STATE.panJustAdded = false;
    render();
  }

  function buildPanBlock() {
    var data = panData();
    if (!data && !PAN) return '';
    if (!STATE.panVariantId && STATE.panUserIntent !== 'removed') {
      return (
        '<div class="gbc-pan-prompt" role="group" aria-label="' + S.panPromptHeadline + '">' +
          '<p class="gbc-pan-prompt__headline">' + S.panPromptHeadline + '</p>' +
          '<p class="gbc-pan-prompt__support">' + S.panPromptSupport + '</p>' +
          '<div class="gbc-pan-prompt__actions">' +
            '<button class="gbc-cta-btn" id="gbc-pan-prompt-yes" type="button">' + S.panPromptYes + '</button>' +
            '<button class="gbc-cta-btn gbc-cta-btn--outline" id="gbc-pan-prompt-no" type="button">' + S.panPromptNo + '</button>' +
          '</div>' +
        '</div>'
      );
    }
    if (!STATE.panVariantId) {
      if (STATE.panUserIntent !== 'removed') return '';
      return (
        '<div style="padding:14px 18px;border-bottom:1px solid var(--gbc-border);">' +
          '<p style="font-size:0.8125rem;color:var(--gbc-muted);font-style:italic;margin:0 0 8px;">' + S.panDisclaimer + '</p>' +
          '<button class="gbc-cta-btn gbc-cta-btn--outline" id="gbc-pan-readd" type="button" style="font-size:0.875rem;padding:10px;">' +
            S.addTheAtomePan + ' · ' + fmt(PAN.price) + ' <s style="font-weight:400;">' + fmt(PAN.comparePrice) + '</s>' +
          '</button>' +
        '</div>'
      );
    }
    var discounted = !STATE.isPanCastIron;
    return (
      '<div class="gbc-cart-section-label" style="display:flex;align-items:center;gap:5px;">' +
        '<span>' + S.yourBakingPan + '</span>' +
        '<button class="gbc-pan-info-btn" data-action="toggle-pan-info" type="button" aria-label="' + S.whyNeedPan + '">?</button>' +
      '</div>' +
      (STATE.panJustAdded ? '<p class="gbc-pan-prompt__added">' + S.panPromptAdded + '</p>' : '') +
      '<div class="gbc-pan-info-panel" id="gbc-pan-info" style="display:none;">' +
        '<p class="gbc-pan-info-panel__title">' + S.whyNeedPanTitle + '</p>' +
        '<ul class="gbc-pan-info-list">' +
          '<li><span class="gbc-pan-info-list__name">' + S.panSteamTrap + '</span><span class="gbc-pan-info-list__desc">' + S.panSteamTrapDesc + '</span></li>' +
          '<li><span class="gbc-pan-info-list__name">' + S.panMadeForAtome + '</span><span class="gbc-pan-info-list__desc">' + S.panMadeForAtomeDesc + '</span></li>' +
          '<li><span class="gbc-pan-info-list__name">' + S.panWithout + '</span><span class="gbc-pan-info-list__desc">' + S.panWithoutDesc + '</span></li>' +
          '<li><span class="gbc-pan-info-list__name">' + S.panLightOrPremium + '</span><span class="gbc-pan-info-list__desc">' + S.panLightOrPremiumDesc + '</span></li>' +
        '</ul>' +
      '</div>' +
      '<div class="gbc-pan-item gbc-pan-item--compact">' +
        '<div class="gbc-pan-item__img">' + (data.image ? '<img src="' + data.image + '" alt="' + data.title + '" width="52" height="52" loading="lazy">' : '') + '</div>' +
        '<div class="gbc-pan-item__content">' +
          '<p class="gbc-pan-item__name">' + data.title + ' ' +
            (discounted
              ? '<s>' + fmt(data.comparePrice) + '</s> <strong>' + fmt(data.price) + '</strong> <span class="gbc-free-tag gbc-free-tag--inline">' + S.save + ' ' + fmt(data.comparePrice - data.price) + '</span>'
              : '<strong>' + fmt(data.price) + '</strong>') +
          '</p>' +
          '<p style="font-size:0.75rem;color:var(--gbc-muted);margin:2px 0 6px;">' + S.panNeededForBreads + '</p>' +
          '<div class="gbc-pan-item__actions">' +
            (!STATE.isPanCastIron && CAST_IRON
              ? '<button class="gbc-pan-upgrade-btn" id="gbc-pan-upgrade" type="button">' + S.upgradeToCastIron + ' · ' + fmt(CAST_IRON.price) + '</button>'
              : (STATE.isPanCastIron ? '<button class="gbc-pan-upgrade-btn" id="gbc-pan-downgrade" type="button">' + S.switchToAluminium + '</button>' : '')) +
            '<button class="gbc-pan-remove-btn" id="gbc-pan-remove" type="button">' + S.remove + '</button>' +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }

  function buildBoxBlock() {
    if (!BOX) return '';
    var contents = (BOX.contents || []).map(function (line) {
      return '<li class="text-sm text-subdued">' + line + '</li>';
    }).join('');
    return (
      '<div class="gbc-cart-section-label">' + S.yourSelections + '</div>' +
      '<div class="gbc-cart-item">' +
        '<div class="gbc-cart-item__img">' + (BOX.image ? '<img src="' + BOX.image + '" alt="' + BOX.title + '" width="48" height="48" loading="lazy">' : '') + '</div>' +
        '<div class="gbc-cart-item__info">' +
          '<p class="gbc-cart-item__name">' + BOX.title + (STATE.qty > 1 ? ' × ' + STATE.qty : '') + '</p>' +
          '<p class="gbc-cart-item__price">' + fmt(boxCents()) + ' <span class="gbc-cart-item__note">' + S.oneTime + '</span></p>' +
          (contents ? '<ul class="list-disc" style="margin:6px 0 0;padding-left:1.1em;">' + contents + '</ul>' : '') +
        '</div>' +
        '<div class="gbc-cart-item__right">' +
          '<button class="gbc-cart-item__remove" id="gbc-box-remove" type="button" aria-label="' + S.remove + '">✕</button>' +
        '</div>' +
      '</div>'
    );
  }

  function buildFooter() {
    var total = totalCents();
    var freeShip = boxCents() >= shipThresholdCents();
    var shipNote = (freeShip && SHIP.note)
      ? '<a class="gbc-footer-ship__note" href="' + esc(SHIP.noteUrl || '/pages/delivery-area') + '">' + esc(SHIP.note) + '</a>'
      : '';
    return (
      '<div class="gbc-footer-compact">' +
        (STATE.checkoutError ? '<p class="gbc-footer-error" role="alert">' + String(STATE.checkoutError).replace(/&/g, '&amp;').replace(/</g, '&lt;') + '</p>' : '') +
        '<div class="gbc-footer-compact__row gbc-footer-compact__row--summary">' +
          '<span class="gbc-footer-compact__sub-label">' + S.subtotal + '</span>' +
          '<div class="gbc-footer-compact__subtotal">' +
            '<span class="gbc-footer-compact__sub-amount">' + fmt(total) + '</span>' +
          '</div>' +
        '</div>' +
        '<div class="gbc-footer-ship' + (freeShip ? ' gbc-footer-ship--reached' : ' gbc-footer-ship--muted') + '">' +
          '<span class="gbc-footer-ship__pill">' +
            '<span class="gbc-footer-ship__icon" aria-hidden="true">' + (freeShip ? '✓' : '🚚') + '</span>' +
            '<span class="gbc-footer-ship__label">' + (freeShip ? S.shipNode : S.shippingFeeApplies) + '</span>' +
          '</span>' +
          shipNote +
        '</div>' +
        '<button class="gbc-cta-btn" id="gbc-checkout-btn" type="button">' +
          (STATE.panUserIntent === null && !STATE.panVariantId && PAN ? S.choosePanOption : (S.checkout + ' · ' + fmt(total))) +
        '</button>' +
      '</div>'
    );
  }

  function render() {
    var body = $('gbc-drawer-body');
    var footer = $('gbc-drawer-footer');
    if (body) body.innerHTML = buildPanBlock() + buildBoxBlock();
    if (footer) footer.innerHTML = buildFooter();
    bindRendered();
  }

  function bindRendered() {
    var infoBtn = document.querySelector('#gbc-drawer-body [data-action="toggle-pan-info"]');
    if (infoBtn) {
      infoBtn.addEventListener('click', function () {
        var panel = $('gbc-pan-info');
        if (panel) panel.style.display = panel.style.display === 'none' ? 'block' : 'none';
      });
    }
    var removeBtn = $('gbc-pan-remove');
    if (removeBtn) removeBtn.addEventListener('click', showPanWarning);
    var readd = $('gbc-pan-readd');
    if (readd) readd.addEventListener('click', addPan);
    var promptYes = $('gbc-pan-prompt-yes');
    if (promptYes) promptYes.addEventListener('click', addPan);
    var promptNo = $('gbc-pan-prompt-no');
    if (promptNo) promptNo.addEventListener('click', declinePan);
    var up = $('gbc-pan-upgrade');
    if (up) {
      up.addEventListener('click', function () {
        if (!CAST_IRON) return;
        STATE.panVariantId = CAST_IRON.variantId;
        STATE.isPanCastIron = true;
        STATE.panUserIntent = 'added';
        render();
      });
    }
    var down = $('gbc-pan-downgrade');
    if (down) {
      down.addEventListener('click', function () {
        if (!PAN) return;
        STATE.panVariantId = PAN.variantId;
        STATE.isPanCastIron = false;
        STATE.panUserIntent = 'added';
        render();
      });
    }
    var checkout = $('gbc-checkout-btn');
    if (checkout) checkout.addEventListener('click', handleCheckout);
    var boxRemove = $('gbc-box-remove');
    if (boxRemove) boxRemove.addEventListener('click', removeBoxAndClose);
  }

  function removeBoxAndClose() {
    STATE.panUserIntent = 'added';
    STATE.isPanCastIron = false;
    STATE.panVariantId = PAN ? PAN.variantId : null;
    closeCart();
  }

  function showLoading(on) {
    var el = $('gbc-loading');
    if (el) el.classList.toggle('gbc-loading-overlay--visible', on);
  }

  function checkoutError(code, cause) {
    var e = new Error(code);
    e.name = 'CheckoutError';
    e.code = code;
    e.cause = cause;
    return e;
  }

  // Same shape as the builder's fetchWithTimeout: abort plus a hard deadline,
  // so a hung connection becomes a clear error instead of a stuck overlay.
  function fetchWithTimeout(url, opts, ms, label) {
    var ctrl = (typeof AbortController === 'function') ? new AbortController() : null;
    var merged = Object.assign({}, opts || {});
    if (ctrl) merged.signal = ctrl.signal;
    var timer;
    var deadline = new Promise(function (_, reject) {
      timer = setTimeout(function () {
        if (ctrl) ctrl.abort();
        reject(checkoutError(label + '_timeout'));
      }, ms);
    });
    return Promise.race([fetch(url, merged), deadline]).then(
      function (res) { clearTimeout(timer); return res; },
      function (e) {
        clearTimeout(timer);
        if (e && e.name === 'CheckoutError') throw e;
        if (e && e.name === 'AbortError') throw checkoutError(label + '_timeout', e);
        throw checkoutError(label + '_error', e);
      }
    );
  }

  function clearCart() {
    return fetchWithTimeout('/cart/clear.js', { method: 'POST' }, CHECKOUT_CART_TIMEOUT_MS, 'cart_clear')
      .then(function (res) {
        if (!res.ok) throw checkoutError('cart_clear_status');
        return res;
      });
  }

  function resolveGiftNote() {
    return fetch('/products/' + GIFT_NOTE_HANDLE + '.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (product) {
        if (!product || !product.variants || !product.variants.length) return null;
        return { variantId: product.variants[0].id };
      })
      .catch(function () { return null; });
  }

  function scrollPromptInCart(prompt) {
    if (!prompt) return;
    var scroller = prompt.closest('.gbc-drawer__body') || $('gbc-drawer-body');
    if (scroller) {
      var promptTop = prompt.getBoundingClientRect().top;
      var scrollerTop = scroller.getBoundingClientRect().top;
      var offset = promptTop - scrollerTop - Math.max(12, (scroller.clientHeight - prompt.offsetHeight) / 3);
      var nextTop = scroller.scrollTop + offset;
      if (typeof scroller.scrollTo === 'function') {
        scroller.scrollTo({ top: Math.max(0, nextTop), behavior: 'smooth' });
      } else {
        scroller.scrollTop = Math.max(0, nextTop);
      }
      return;
    }
    if (typeof prompt.scrollIntoView === 'function') {
      prompt.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  function showPanChoiceGate() {
    window.setTimeout(function () {
      var prompt = document.querySelector('.gbc-pan-prompt');
      if (prompt) {
        prompt.classList.remove('gbc-pan-prompt--gate');
        void prompt.offsetWidth;
        prompt.classList.add('gbc-pan-prompt--gate');
        scrollPromptInCart(prompt);
      }
    }, 30);
  }

  async function handleCheckout() {
    if (STATE.panUserIntent === null && !STATE.panVariantId && PAN) {
      showPanChoiceGate();
      return;
    }
    if (STATE.checkoutInProgress) return;
    if (!BOX || !BOX.variantId) return;
    STATE.checkoutInProgress = true;
    STATE.checkoutError = '';
    // The overlay (z 11000) would otherwise sit over an open pan modal (z 10500).
    closePanWarning();
    showLoading(true);
    try {
      try {
        await clearCart();
      } catch (firstErr) {
        await clearCart(); // one retry on clear only
      }

      var boxProps = Object.assign({}, STATE.properties);
      var message = boxProps['Gift message'] ? String(boxProps['Gift message']).trim() : '';
      var giftNote = message ? await resolveGiftNote() : null;
      if (giftNote && message) delete boxProps['Gift message'];
      boxProps._gift = 'true';

      var items = [{
        id: BOX.variantId,
        quantity: STATE.qty,
        properties: boxProps
      }];
      if (STATE.panVariantId) {
        items.push({
          id: STATE.panVariantId,
          quantity: 1,
          properties: { _gift_pan: 'true' }
        });
      }
      if (giftNote && message) {
        items.push({
          id: giftNote.variantId,
          quantity: 1,
          properties: { 'Gift message': message, _gift: 'true' }
        });
      }

      var addRes = await fetchWithTimeout('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }, CHECKOUT_CART_TIMEOUT_MS, 'cart_add');
      if (!addRes.ok) {
        var err = await addRes.json().catch(function () { return {}; });
        throw new Error(err.description || S.alertCartError);
      }
      // Truth and Reconciliation Day gift line (assets/trc-gift.js). Bounded, never throws.
      if (window.AtomeTRC) await window.AtomeTRC.ensure();
      window.location.href = '/checkout';
    } catch (err) {
      STATE.checkoutInProgress = false;
      showLoading(false);
      var code = err && err.code ? String(err.code) : '';
      if (code === 'cart_clear_status') STATE.checkoutError = S.alertCartFail;
      else if (code) STATE.checkoutError = S.checkoutNetworkError;
      else STATE.checkoutError = (err && err.message) ? err.message : S.alertCartError;
      render();
    }
  }

  document.addEventListener('submit', function (e) {
    interceptGift(e, e.target);
  }, true);

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('button[type="submit"], input[type="submit"]') : null;
    if (!btn) return;
    interceptGift(e, btn.form || btn.closest('form'));
  }, true);

  // Back from /checkout restores this page from bfcache as it was left:
  // overlay up, checkout locked. Reset both, nothing else.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    STATE.checkoutInProgress = false;
    showLoading(false);
  });

  function ready() {
    document.querySelectorAll('form[is="product-form"]').forEach(function (form) {
      if (isGiftForm(form)) form.setAttribute('data-gbc-form', 'true');
    });
    var closeBtn = $('gbc-drawer-close');
    if (closeBtn) closeBtn.addEventListener('click', closeCart);
    var backdrop = $('gbc-backdrop');
    if (backdrop) backdrop.addEventListener('click', closeCart);
    var keep = $('gbc-pan-warning-cancel');
    if (keep) keep.addEventListener('click', closePanWarning);
    var drop = $('gbc-pan-warning-confirm');
    if (drop) drop.addEventListener('click', removePan);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && STATE.open) closeCart();
      if (e.key === 'Enter' && STATE.open) {
        var tag = (e.target && e.target.tagName) ? e.target.tagName.toLowerCase() : '';
        if (tag === 'input' || tag === 'textarea' || tag === 'select') return;
        if (!$('gbc-pan-prompt-yes')) return;
        e.preventDefault();
        addPan();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }
})();
